export default {
  "interaction.success.orderUnitRequestApproval":
    "Die Bestelleinheit wurde erfolreich zur Prüfung freigegeben",
  "interaction.success.orderUnitProductUpdate":
    "Bestelleinheit erfolreich geändert",
  "interaction.success.orderUnitProductUpdate.ADD":
    "Produkt erfolreich zur Bestelleinheit hinzugefügt",
  "interaction.success.orderUnitProductUpdate.UPDATE":
    "Produktanzahl erfolreich geändert",
  "interaction.success.orderUnitProductUpdate.REMOVE":
    "Produkt erfolreich aus der Bestelleinheit entfernt",
};
